import type { FindFn } from "@shared/models/analytics/base"
import type { EditorOpenMenuEvent } from "@shared/unified-tiptap/analytics/open-menu-event"
import { partial } from "lodash-es"
import type { PreparedAction } from "@shared/actions/action-doc-builder"
import type { Narrative } from "@shared/actions/create-narrative"
import defaultLessonContext from "./default-lesson-context"
import defaultLessonModels from "./default-lesson-models"

interface Payload {
  cardStackId: string
  planbookId: string
  courseId: string | null
  dateString: string | null
  event: EditorOpenMenuEvent
}

/**
 * The analytics-only action one menu opening dispatches. It carries no patches: nothing about the
 * lesson changed, and this reports the fact the editor stated at the moment it happened.
 */
export function prepareEditorOpenMenu(payload: Payload): PreparedAction {
  return {
    name: "LESSON_EDITOR_OPEN_MENU",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, findFn: FindFn, userId: string): Narrative {
  const { event } = payload
  const models = defaultLessonModels(payload, findFn, userId)

  return {
    titleForAnalytics: "Editor - Open Menu",
    context: {
      ...defaultLessonContext(payload, models),
      editorMenuSurface: event.surface,
      cardId: event.cardId,
      occurredAt: event.occurredAt,
    },
    newAnalyticsEvents: [],
    isQuiet: true,
  }
}
